import type { AppData, NotificationPreferences } from "../../types";
import { el, statusLabel } from "../atoms/dom";
import { panel } from "./dashboard_page";

export function managePage(
  data: AppData,
  onUpdateNotificationPreferences: (
    preferences: NotificationPreferences,
  ) => Promise<void>,
) {
  const organization = data.organizations[0];
  const branch = data.branches[0];
  const agent = data.agents[0];
  return el("div", { className: "page-stack" },
    el("section", { className: "manage-hero" }, el("span", { className: "eyebrow", text: "İŞLETME PROFİLİ" }), el("h2", { text: organization?.name ?? data.user.displayName }), el("p", { text: `${organization?.category ?? "İşletme"} · ${branch?.telephoneNumber ?? data.user.verifiedPhoneNumber}` })),
    el("div", { className: "manage-grid" },
      panel("AI asistan", el("div", { className: "settings-list" }, setting("Asistan adı", agent?.name ?? "—"), setting("Ses", agent?.voice ?? "—"), setting("Karşılama mesajı", agent?.greeting ?? "—"), setting("Durum", agent ? statusLabel(agent.status) : "—"))),
      panel("Hizmetler", el("div", { className: "settings-list" }, ...data.services.map((service) => setting(service.name, `${service.durationMinutes} dakika`)))),
      panel("Ekip", el("div", { className: "settings-list" }, ...data.staff.map((person) => setting(person.name, person.profession || (person.active ? "Aktif" : "Pasif"))))),
      panel("Randevu entegrasyonları", el("div", { className: "settings-list" }, ...(data.integrations.length ? data.integrations.map((integration) => setting(integration.providerDisplayName, statusLabel(integration.status))) : [el("p", { className: "muted", text: "Henüz entegrasyon eklenmemiş." })]))),
      notificationPreferencesPanel(
        data.notificationPreferences,
        onUpdateNotificationPreferences,
      ),
    ),
    el("aside", { className: "manage-note" }, el("strong", { text: "Web oturumları mobil uygulamadan yönetilir" }), el("p", { text: "Yeni bilgisayar bağlamak veya açık bir web oturumunu kapatmak için mobil uygulamada Yönet > Web oturumları bölümünü kullanın." })),
  );
}

function notificationPreferencesPanel(
  preferences: NotificationPreferences,
  onUpdate: (preferences: NotificationPreferences) => Promise<void>,
) {
  const feedback = el("p", {
    className: "preference-feedback",
    attrs: { "aria-live": "polite" },
  });
  const root = el("div", { className: "preference-list" });

  function preference(
    label: string,
    description: string,
    key: keyof NotificationPreferences,
  ) {
    const input = el("input", {
      attrs: {
        type: "checkbox",
        role: "switch",
        "aria-label": label,
      },
    });
    input.checked = preferences[key];
    input.addEventListener("change", async () => {
      const previous = preferences[key];
      input.disabled = true;
      feedback.textContent = "Kaydediliyor…";
      try {
        await onUpdate({ ...preferences, [key]: input.checked });
        feedback.textContent = "Bildirim tercihi kaydedildi.";
      } catch {
        input.checked = previous;
        input.disabled = false;
        feedback.textContent = "Bildirim tercihi kaydedilemedi.";
        feedback.classList.add("is-error");
      }
    });
    return el(
      "label",
      { className: "preference-row" },
      el(
        "span",
        {},
        el("strong", { text: label }),
        el("small", { text: description }),
      ),
      input,
    );
  }

  root.append(
    preference(
      "Canlı görüşmeler",
      "Yapay zekâ yeni bir telefon görüşmesine başladığında bildirim alın.",
      "liveCallStarted",
    ),
    preference(
      "Yeni randevular",
      "Yeni bir randevu oluşturulduğunda bildirim alın.",
      "appointmentCreated",
    ),
    feedback,
  );
  return panel("Bildirim tercihleri", root);
}

function setting(label: string, value: string | HTMLElement) {
  return el("div", { className: "setting-row" }, el("span", { text: label }), typeof value === "string" ? el("strong", { text: value }) : value);
}
